class SoldoutVariantBlock extends HTMLElement {
   connectedCallback() {
      this._onVariantChangedListener = this._onVariantChanged.bind(this);
      document.addEventListener('variant:change', this._onVariantChangedListener);
   }

   disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChangedListener);
   }

   _onVariantChanged(event) {
      const variant = event.detail?.variant;
      if (!variant) return;
      this.classList.toggle('--is-sold-out', !variant.available);
   }
}

customElements.define('soldout-variant-block', SoldoutVariantBlock);
